export default "__VITE_ASSET__BtRPnP0k__"